import { Competency, LearnerOutcome } from "@/lib/models";
import { OutcomeAreaCompetencyList } from "./OutcomeAreaCompetencyList";
import { HtmlRenderer } from "../HtmlRenderer";
import Image from "next/image";
import { IconButton } from "@heathmont/moon-core-tw";
import ChevronUp from "../icons/ChevronUp";

type CompetencyDetailSmallModalProps = {
  learnerOutcome: LearnerOutcome;
  activeCompetency?: Competency;
  changeCompetency: (competencyId: string) => Promise<void>;
  className?: string;
  handleModal: () => void;
};

export const CompetencyDetailSmallModal = ({
  learnerOutcome,
  changeCompetency,
  className,
  handleModal,
}: CompetencyDetailSmallModalProps) => {
  const handleCompetencyChange = (competencyId: string) => {
    handleModal();
    return changeCompetency(competencyId);
  };
  return (
    <div
      role="dialog"
      aria-modal={true}
      aria-label="competency-modal"
      className={`${className} col-span-full mx-2 mb-2 h-fit overflow-hidden
      rounded-lg border border-stone-200 bg-white pb-2 shadow-lg medium:col-span-3 medium:block`}
    >
      <div className="inline-flex w-full items-center justify-between px-4 py-3 font-roobert text-base font-medium leading-none">
        <span>Select a Competency...</span>
        <IconButton
          aria-label="Close competency dropdown"
          icon={<ChevronUp />}
          onClick={handleModal}
        ></IconButton>
      </div>

      <div className="col-span-full border-t border-tab-border"></div>
      <div className="flex-col medium:flex">
        <div className="flex">
          <div className="my-4 ml-4 h-[48px] w-[42px]">
            {learnerOutcome.learnerOutcomeCard.sourceUrl && (
              <Image
                src={learnerOutcome.learnerOutcomeCard.sourceUrl}
                alt=""
                width={42}
                height={48}
              />
            )}
          </div>
          <div className="mx-3 flex w-[169px] flex-col justify-center text-left">
            <div className="pb-1 font-roobert text-[6px] font-medium uppercase text-black">
              Learner Outcome
            </div>
            <div className="font-roobert font-[16px] leading-none text-black">
              {learnerOutcome.name}
            </div>
          </div>
        </div>

        <div className="mx-4 mt-3 font-roobert text-[14px] text-gray-text">
          <HtmlRenderer html={learnerOutcome.description} />
        </div>
      </div>

      <div className="mt-4 hidden border-t border-tab-border medium:flex"></div>
      <h2 className="mx-4 mt-4 font-roobert text-xs font-medium uppercase leading-tight text-black">
        Competencies
      </h2>
      {learnerOutcome.outcomeAreas.map((outcomeAreaId) => (
        <OutcomeAreaCompetencyList
          key={outcomeAreaId}
          outcomeAreaId={outcomeAreaId}
          learnerOutcomeId={learnerOutcome.id}
          changeCompetency={handleCompetencyChange}
        />
      ))}
    </div>
  );
};
